import { MiddleClassCodeComboBoxComponent } from '../middle-class-code-combo-box/middle-class-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * 中分類コードコンボボックスManageクラス
 *
 * @export MiddleClassCodeComboBoxModel
 * @class MiddleClassCodeComboBoxModel
 */
export class MiddleClassCodeComboBoxModel {

  public middleClassList = [];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: MiddleClassCodeComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setMiddleClassCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // 初期設定インデックス
  public setSelectedIndex = -1;
  // 受注コード初期化済フラグ
  public isInitOrderCode: boolean = <boolean>false;


  /**
   * 中分類コードリストアップデート
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof MiddleClassCodeComboBoxModel
   */
  public updateMiddleClassList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加

    if (this.blank) {
      const ob = {
        ClassCode: '',
        LargeClassCode: '',
        MiddleClassCode: '',
        MiddleClassName: '',
        MiddleClassCodeName: '',
      };
      tempDataList.splice(index, 0, ob);
      index += 1;
    }

    // テンプから表示用に設定する
    this.middleClassList = tempDataList;
    // テンプレートリスト生成完了フラグセット
    this.completeUpdateFlg = true;

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].MiddleClassCodeName
        = tempDataList[index].MiddleClassCode + ':' + tempDataList[index].MiddleClassName;
    }
    this.middleClassList = tempDataList;
    this.component.updateSelectedMiddleClassCode();
    this.component.updateSelectedIndex();
  }

}
